const LOCAL_API_BASE_URL = 'http://localhost:5000';
const LOCAL_CLIENT_BASE_URL = 'http://localhost:3000';
const PRODUCTION_DOMAIN = 'marrycenter.com';
const PRODUCTION_API_BASE_URL = 'https://api.marrycenter.com';

const isBrowser = typeof window !== 'undefined';
const isLocalHostname = (hostname) => ['localhost', '127.0.0.1'].includes((hostname || '').toLowerCase());

const normalizeUrl = (url) => {
  if (!url) return null;
  return url.endsWith('/') ? url.slice(0, -1) : url;
};

const resolveDefaultApiBaseUrl = () => {
  if (!isBrowser) {
    return LOCAL_API_BASE_URL;
  }

  const { hostname, origin } = window.location;

  if (isLocalHostname(hostname)) {
    return LOCAL_API_BASE_URL;
  }

  const normalizedHost = (hostname || '').toLowerCase();
  if (normalizedHost === PRODUCTION_DOMAIN || normalizedHost === `www.${PRODUCTION_DOMAIN}`) {
    // Frontend is served from marrycenter.com – always talk to the API subdomain
    return PRODUCTION_API_BASE_URL;
  }

  return origin;
};

const normalizeMediaUrl = (absoluteUrl) => {
  try {
    const parsed = new URL(absoluteUrl);
    const hostname = parsed.hostname.toLowerCase();

    if (isLocalHostname(hostname)) {
      // Replace localhost file URLs with the active API base so we avoid mixed-content on HTTPS
      return `${API_BASE_URL}${parsed.pathname}${parsed.search}${parsed.hash}`;
    }

    if (hostname.endsWith(PRODUCTION_DOMAIN) && parsed.protocol === 'http:') {
      parsed.protocol = 'https:';
      return parsed.toString();
    }

    return parsed.toString();
  } catch {
    return absoluteUrl;
  }
};

const DEFAULT_API_BASE_URL = resolveDefaultApiBaseUrl();
const ENV_API_BASE_URL = normalizeUrl(process.env.REACT_APP_API_BASE_URL);
const ENV_SOCKET_BASE_URL = normalizeUrl(process.env.REACT_APP_SOCKET_URL);
const ENV_CLIENT_BASE_URL = normalizeUrl(process.env.REACT_APP_CLIENT_URL);

const shouldForceLocal = isBrowser && isLocalHostname(window.location.hostname);

export const API_BASE_URL = shouldForceLocal
  ? LOCAL_API_BASE_URL
  : (ENV_API_BASE_URL || DEFAULT_API_BASE_URL);

export const SOCKET_BASE_URL = shouldForceLocal
  ? LOCAL_API_BASE_URL
  : (ENV_SOCKET_BASE_URL || API_BASE_URL);

export const CLIENT_BASE_URL = shouldForceLocal
  ? LOCAL_CLIENT_BASE_URL
  : (ENV_CLIENT_BASE_URL || (isBrowser ? window.location.origin : LOCAL_CLIENT_BASE_URL));

export const buildApiUrl = (path = '') => {
  if (!path) {
    return API_BASE_URL;
  }
  return `${API_BASE_URL}${path.startsWith('/') ? path : `/${path}`}`;
};

export const buildMediaUrl = (path) => {
  if (!path) return null;

  if (path.startsWith('http://') || path.startsWith('https://')) {
    return normalizeMediaUrl(path);
  }

  return `${API_BASE_URL}${path.startsWith('/') ? path : `/${path}`}`;
};
